import { Cookies } from "react-cookie";
import cookiesKeys from "Common/cookies/cookiesKeys";
const getCookieHunter = () => {
    const cookies = new Cookies();
    return cookies.get(cookiesKeys.hunter);
};
export default getCookieHunter;
